import HTMLReactParser from "html-react-parser";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MagicResearchStep } from "../../../lib/types";
import { investMagicResearch } from "../../../store/actions";
import { DragescentState } from "../../../store/reducers/stateType";

interface IProps {
  govId?: number;
  step: MagicResearchStep;
  level: number;
  active: boolean;
  available: boolean;
}

const MagicResearchStepInfo = ({
  govId,
  step,
  active,
  available
}: IProps) => {
  const dispatch = useDispatch();
  const id = useSelector((state: DragescentState) => state.governorate.id);

  return (
    <>
      <h3 className="title">Level {step.id}</h3>
      <p className="text-center">
        {HTMLReactParser(step.description)}
      </p>
      <p>
        Requires:<br/>
        {HTMLReactParser(step.prerequisity)}<br/>
      </p>
      {!active && available
        ? <a href="#"
             onClick={() => dispatch(investMagicResearch(govId, !govId || govId === id))}
             className="btn btn-black btn-sm"
             tabIndex={0}
        >
          INVEST
        </a>
        : <></>}
    </>
  )
}

export default MagicResearchStepInfo;
